import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {sleep} from 'src/smoothr-web-app-core/utils/utils';
import {Router} from '@angular/router';
import {MenuPage} from 'src/app/pages/menu/menu.page';

@Component({
	selector: 'app-short-location-notification-modal',
	templateUrl: './short-location-notification-modal.component.html',
	styleUrls: ['short-location-notification-modal.component.scss']
})
export class ShortLocationNotificationModalComponent implements OnInit {
	constructor(
		private modalCtrl: ModalController,
		private route: Router
	) {}

	ngOnInit() {}
	static async show(modalCtrl: ModalController): Promise<any> {
		const modal = await modalCtrl.create({
			cssClass: 'short-location-notification-modal auto-height',
			component: ShortLocationNotificationModalComponent,
			componentProps: {},
			showBackdrop: true,
			backdropDismiss: true
		});
		await modal.present();
		const result = await modal.onDidDismiss();
		sleep(100);
		return result.data;
	}

	back() {
		this.dismiss();
	}

	success() {
		this.modalCtrl.dismiss('success');
	}

	dismiss() {
		this.modalCtrl.dismiss();
	}
}
